module.exports = __webpack_public_path__ + "media/RELIGION_TEMP_MUSIC.c3cfe246.mp3";